import type { ServiceGroup } from '../lib/service-groups';
import { GROUP_HEADER_COLORS, GROUP_NOTES } from '../lib/service-groups';

interface ServiceGroupHeaderProps {
  group: ServiceGroup;
  note?: string;
  collapsed?: boolean;
  onToggle?: () => void;
}

function ChevronDown({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

export default function ServiceGroupHeader({
  group,
  note,
  collapsed,
  onToggle,
}: ServiceGroupHeaderProps) {
  const groupNote = note ?? GROUP_NOTES[group];

  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1.5">
        {onToggle && (
          <button
            type="button"
            onClick={onToggle}
            className="p-0.5 rounded hover:bg-white/30 transition-colors text-gray-400 hover:text-gray-600"
            title={collapsed ? 'Expand group' : 'Collapse group'}
          >
            <ChevronDown
              className={`w-3.5 h-3.5 transition-transform ${
                collapsed ? '-rotate-90' : ''
              }`}
            />
          </button>
        )}
        <span
          className={`inline-flex items-center px-2 py-0.5 rounded text-white text-xs font-bold uppercase tracking-wider ${
            GROUP_HEADER_COLORS[group]
          }`}
        >
          {group}
        </span>
      </div>
      {groupNote && (
        <p className="text-[11px] text-gray-500 dark:text-gray-400 pl-6">
          {groupNote}
        </p>
      )}
    </div>
  );
}

export type { ServiceGroup };
